import React from "react";
import MarketingHeader from "../../components/MarketingHeader";
import MarketingFooter from "../../components/MarketingFooter";
import Hero from "./sections/Hero";
import ProofBar from "./sections/ProofBar";
import SignatureFlow from "./sections/SignatureFlow";
import DayInLife from "./sections/DayInLife";
import FeatureGrid from "./sections/FeatureGrid";
import TrustSection from "./sections/TrustSection";
import Testimonial from "./sections/Testimonial";
import KnowledgeCards from "./sections/KnowledgeCards";
import FAQ from "./sections/FAQ";
import CurvedCloser from "./sections/CurvedCloser";
import { FONT_STACK, TEXT_INK, BG_PAGE } from "./tokens";

export default function EmployeePortal() {
  return (
    <div style={{ fontFamily: FONT_STACK, color: TEXT_INK, background: BG_PAGE }}>
      <MarketingHeader />
      <Hero />
      <ProofBar />
      <SignatureFlow />
      <DayInLife />
      <FeatureGrid />
      <TrustSection />
      <Testimonial />
      <KnowledgeCards />
      <FAQ />
      <CurvedCloser />
      <MarketingFooter />
    </div>
  );
}